import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-125cb69e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "describe" }, null, -1))
const _hoisted_2 = { class: "zxzbul" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "clearfix" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "gray" }, "指标名称"),
  /*#__PURE__*/_createElementVNode("div", { class: "textright" }, "最新数据"),
  /*#__PURE__*/_createElementVNode("div", { class: "gray" }, "指标名称"),
  /*#__PURE__*/_createElementVNode("div", { class: "textright" }, "最新数据"),
  /*#__PURE__*/_createElementVNode("div", { class: "gray" }, "指标名称"),
  /*#__PURE__*/_createElementVNode("div", { class: "textright" }, "最新数据")
], -1))
const _hoisted_4 = { class: "clearfix" }
const _hoisted_5 = { class: "gray" }
const _hoisted_6 = { class: "nametag" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "clearfix" }
const _hoisted_10 = { class: "onerow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoCircleOutlined = _resolveComponent("InfoCircleOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, {
    tip: "加载中...",
    spinning: _ctx.spinning
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", null, [
        _hoisted_1,
        _createElementVNode("ul", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("li", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, i) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: 'list' + i
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createTextVNode(_toDisplayString(item.name), 1),
                  (item.tip)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        title: item.tip
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_InfoCircleOutlined)
                        ]),
                        _: 2
                      }, 1032, ["title"]))
                    : _createCommentVNode("", true),
                  (item.tag && item.time)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 1,
                        placement: "top",
                        arrowPointAtCenter: "",
                        getPopupContainer: _ctx.getPopupContainer,
                        align: { offset: [0, 4] }
                      }, {
                        title: _withCtx(() => [
                          _createElementVNode("span", null, " 数据来源：业绩" + _toDisplayString(item.tag) + "报， " + _toDisplayString(_ctx.moment(item.time * 1000).format('YYYY年')) + " " + _toDisplayString(_ctx.setquarter(item.time * 1000)) + "季报 ", 1)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_6, _toDisplayString(item.tag) + _toDisplayString(_ctx.moment(item.time * 1000).quarter()), 1)
                        ]),
                        _: 2
                      }, 1032, ["getPopupContainer"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", {
                  class: "textright",
                  style: _normalizeStyle(_ctx.theme !== 'dark' ? 'color: #1d1d1d' : 'color: #D7D7DF')
                }, [
                  (typeof item.num === 'object')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                        _createElementVNode("span", {
                          style: _normalizeStyle({ color: item.num.color })
                        }, _toDisplayString(item.num.text), 5)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.num), 1))
                ], 4)
              ], 64))
            }), 128))
          ]),
          _createElementVNode("li", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, " 数据来源：上述数据来源于" + _toDisplayString(_ctx.newsIndexDetails?.year) + "年" + _toDisplayString(_ctx.getReportTypeName(_ctx.newsIndexDetails?.reportType)) + "，币种为" + _toDisplayString(_ctx.getCurrencyName(_ctx.newsIndexDetails?.currencyCode)), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["spinning"]))
}